import React from 'react';
import TeamsIcon from "../../../assets/icons/Microsoft_Teams.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import Linked from './Linked';
import { MICROSOFT_TEAMS_ID } from '../../../data/integration-app';

const MicrosoftTeams = ({connectedVenues}) => {
    return (
        <Col md="6" xxl="3" xl="4">
            <Link to="/integrations/ms-teams" className="int-col">
            {connectedVenues.some(data => parseInt(data.app_id) === MICROSOFT_TEAMS_ID) && <Linked />}
            <div className="img">
                <img src={TeamsIcon} alt="Google Calendar" />
            </div>
            <div className="text">
                <h3>Microsoft Teams</h3>
                <p>
                    Collaborate and meet instantly with Microsoft Teams — chat, video, and files all in one place.
                </p>
            </div>
            </Link>
        </Col>
    );
}

export default MicrosoftTeams;